export default __webpack_public_path__ + "static/media/arrow.4ebc3a1b.svg";